import React, { useState } from 'react';
import { Card } from 'antd';
import { HistoryHeading, HistoryPanel, type HistoryMode } from './History';
import { buildPlatformResultLink } from '../../shared/lib/platformShareLink';

// Страница истории живёт на странице платформы: адрес расчёта — её `?result=<id>`.
const platformResultHref = (resultId: number) => buildPlatformResultLink(window.location.origin, resultId);

interface HistoryPageProps {
  /** Вкладка истории открыта — список перечитывается на каждом входе в неё. */
  active: boolean;
  onLoadResult: (fileName: string) => void;
  onLoadShared: (data: Record<string, unknown>) => void;
}

/**
 * История расчётов отдельной страницей — вкладка «История расчётов» рядом с «Расчётом»
 * (макет WS 15587410, фидбек 25.09 и QA 08.10, п.1). Шторка поверх расчёта на странице
 * платформы была мелкой и закрывала сам расчёт; здесь у таблицы вся ширина модуля, и
 * открывается история сразу таблицей.
 */
const HistoryPage: React.FC<HistoryPageProps> = ({ active, onLoadResult, onLoadShared }) => {
  const [mode, setMode] = useState<HistoryMode>('table');
  return (
    <Card title={<HistoryHeading mode={mode} onModeChange={setMode} />}>
      <HistoryPanel active={active} mode={mode} onLoadResult={onLoadResult} onLoadShared={onLoadShared} resultHref={platformResultHref} />
    </Card>
  );
};

export default HistoryPage;
